import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAdminLoggedIn = localStorage.getItem("authToken");

  if (!isAdminLoggedIn) {
    return <Navigate to="/home" />;
  }

  return children;
};

export default ProtectedRoute;
